import { VisierAnalytics } from 'Deer/components/Visier/VisierAnalytics';
import { Header } from 'Deer/components/common/Header';

const OutcomesDashboard = () => (
  <>
    <Header title="Outcomes Dashboard" />
    <VisierAnalytics id="outcomesDashboard" />
  </>
);

export { OutcomesDashboard };
